import { useEffect, useState } from "react";
import { ButtonVariant, Checkbox, Dialog, Text } from "@merge-api/merge-javascript-shared";

interface Props {
  selectedObjectType: string;
  associatedObjectsName?: string | null;
  show: boolean;
  onHide: () => void;
  isLoading: boolean;
  onConfirm: () => void;
  objectName?: string | null;
}

function DeletionConfirmationModal({
  selectedObjectType,
  associatedObjectsName = "step templates",
  show,
  onHide,
  isLoading,
  onConfirm,
  objectName = null,
}: Props) {
  const [isDeletionConfirmationChecked, setDeletionConfirmationChecked] = useState(false);

  useEffect(() => {
    setTimeout(function () {
      setDeletionConfirmationChecked(false);
    }, 3000);
  }, [show]);

  return (
    <Dialog
      title={"Confirm delete " + selectedObjectType}
      open={show}
      onClose={onHide}
      primaryButtonText="Confirm delete"
      primaryButtonVariant={ButtonVariant.PrimaryGray}
      onPrimaryButtonClick={onConfirm}
      primaryButtonLoading={isLoading}
      primaryButtonDisabled={!isDeletionConfirmationChecked}
      secondaryButtonText="Cancel"
      secondaryButtonVariant={ButtonVariant.TextBlack}
      onSecondaryButtonClick={onHide}
      variant="md"
    >
      <div className="flex flex-col gap-y-3">
        {objectName && <Text variant="h6">{objectName}</Text>}
        <Text>Are you sure you want to delete this {selectedObjectType}?</Text>
        {associatedObjectsName && (
          <Text>
            Deleting will <span className="text-red-60 font-semibold">permanently delete</span> any
            associated {associatedObjectsName} currently in use.
          </Text>
        )}
        <Checkbox
          className="mt-3"
          label="I understand that this is an irreversible action"
          checked={isDeletionConfirmationChecked}
          onChange={() => setDeletionConfirmationChecked(!isDeletionConfirmationChecked)}
        />
      </div>
    </Dialog>
  );
}

export default DeletionConfirmationModal;
